import {
  Component,
  ChangeDetectorRef,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Store } from '@ngxs/store';
import { FetchAllUsersIfNeeded, UsersState } from '@wilson/account';
import { firstValueFrom } from 'rxjs';
import { SharedComponentsModule } from '@wilson/shared-components';
import { Router } from '@angular/router';

@Component({
  selector: 'wilson-qualification-user-renderer',
  template: `
    <span
      class="d-flex align-items-center cursor-pointer"
      (click)="openUserDetails()"
    >
      <wilson-user-avatar
        [s3Urn]="profileImage"
        [fallbackImage]="fallbackImage"
        class="avatar"
      ></wilson-user-avatar>
      {{ cellValue }}
    </span>
  `,
  imports: [SharedComponentsModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .avatar {
        margin-right: 4px;
        width: 14px;
        height: 14px;
      }
      .cursor-pointer {
        cursor: pointer;
      }
    `,
  ],
})
export class QualificationUserRendererComponent implements AgRendererComponent {
  private store = inject(Store);
  private cdRef = inject(ChangeDetectorRef);
  private router = inject(Router);

  public cellValue!: string;
  public fallbackImage = 'assets/img/profile/profile-img-placeholder-dark.svg';
  public profileImage: string | null | undefined;
  private userId: string | undefined;

  async agInit(params: ICellRendererParams): Promise<void> {
    this.userId = params.data?.userId;
    this.store.dispatch(new FetchAllUsersIfNeeded());
    if (!this.userId) {
      return;
    } else {
      const user = await firstValueFrom(
        this.store.select(UsersState.userById(this.userId)),
      );
      this.profileImage = user?.profileImageUrl;
      this.cellValue = user
        ? `${user.firstName} ${user.lastName}`
        : 'Unknown User';
      this.cdRef.detectChanges();
    }
  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }

  openUserDetails(event?: MouseEvent): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (this.userId) {
      this.router.navigate(['/employees', this.userId]);
    }
  }
}
